<template>
  <div class="px-3 pb-2 max-h-full h-full">
    <div class="pt-3">
      <RadioButton v-model="payload.type" value="step" name="transitionType" :label="$t('conversations.switch_to_step')" @update:modelValue="onTypeChange" />
      <FormSelect
        v-if="payload.type === 'step'"
        class="mt-2"
        v-model="payload.value"
        :options="steps"
        appendToBody
        :searchable="false"
        :clearable="false"
        default-reducer
        @update:modelValue="emitPayload"
      />
      <RadioButton v-model="payload.type" value="end" name="transitionType" :label="endTransitionText" class="mt-3" @update:modelValue="onTypeChange" />
      <RadioButton v-model="payload.type" value="agent" name="transitionType" :label="agentTransitionText" class="mt-3" @update:modelValue="onTypeChange" />
      <FormSelect
        v-if="payload.type === 'agent'"
        class="mt-2"
        v-model="payload.value"
        :options="flows"
        appendToBody
        :searchable="false"
        :clearable="false"
        default-reducer
        @update:modelValue="emitPayload"
      />
      <VariableSelect
        v-if="payload.type === 'agent'"
        v-model="payload.data_binding"
        multiple
        :label="$t('evaluate.data_binding')"
        class="mt-2 flex-grow"
        selectBgColor="bg-white"
        :filter-data-type="['Text', 'Number', 'Email', 'YesNo', 'Chart', 'DataTable']"
        :showCreate="false"
        @update:modelValue="emitPayload"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { getTransitionText } from '@/helpers/flow';
import EvaluateItemsConfig from './EvaluateItemsConfig';
import debounce from '../../../helpers/debounce';

export default {
  name: 'TransitionConfig',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      payload: structuredClone(EvaluateItemsConfig['logic-transition'].payload),
    };
  },
  computed: {
    ...mapState(['selectedIntentDefinition']),
    ...mapGetters(['getProjectFlows']),
    projectId() {
      return this.$route.params.projectId;
    },
    endTransitionText() {
      return getTransitionText({ type: 'end' }, []);
    },
    agentTransitionText() {
      return getTransitionText({ type: 'agent' }, [], this.flows);
    },
    steps() {
      return this.selectedIntentDefinition.steps.map((s) => ({
        value: s.id,
        label: s.name,
      }));
    },
    flows() {
      return Object.keys(this.getProjectFlows()).map((key) => ({
        label: this.getProjectFlows()[key].name,
        value: key,
      }));
    },
  },
  methods: {
    onTypeChange() {
      this.payload.value = null;
      this.payload.data_binding = [];
    },
    // eslint-disable-next-line
    emitPayload: debounce(function () {
      this.$emit('update', {
        id: this.item.id,
        type: this.item.type,
        payload: this.payload,
      });
    }, 300),
  },
  watch: {
    item: {
      handler() {
        if (this.item) {
          this.payload = JSON.parse(JSON.stringify(this.item.payload));
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
